import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import './download-adobe.scss';

export const DownloadAdobe = () => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext;
  if (channel === 'mobile') {
    return null;
  }
  return (
    <div className="download-adobe__download-message" data-testid="download-message-element">
      You will need Adobe&reg; Acrobat&reg; Reader to view PDF documents.&nbsp;
      <a
        className="u__default-link"
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.adobe.com/products/acrobat/readstep2.html"
        data-target="Download"
      >
        Download
      </a>
      {' '}
      a free copy from the Adobe Web site.
    </div>
  );
};

DownloadAdobe.displayName = 'DownloadAdobe';
